import { tenantCapability } from '@customize/registry';

interface ClinicTenantOption {
  id: number;
  site_type?: string | null;
}

interface ClinicUserSsoPolicyInput {
  routeSiteType: string;
  clinicId?: unknown;
  clinicOptions?: readonly ClinicTenantOption[];
  clinicSiteType?: string | null;
}

const normalizedSiteType = (value: unknown): string | undefined =>
  typeof value === 'string' && value.trim() ? value.trim().toLowerCase() : undefined;

/**
 * Resolve the clinic's tenant independently from the admin route. This matters
 * on the super-admin surface, where one form can select clinics from different
 * tenants while `routeSiteType` remains `super-admin`.
 */
export const resolveClinicUserSiteType = ({
  routeSiteType,
  clinicId,
  clinicOptions,
  clinicSiteType,
}: ClinicUserSsoPolicyInput): string => {
  const numericClinicId = Number(clinicId);
  const selectedClinic = Number.isFinite(numericClinicId)
    ? clinicOptions?.find(option => Number(option.id) === numericClinicId)
    : undefined;

  return normalizedSiteType(selectedClinic?.site_type)
    ?? normalizedSiteType(clinicSiteType)
    ?? normalizedSiteType(routeSiteType)
    ?? '';
};

/** Whether the selected clinic uses the P1 admin SSO-mapping contract. */
export const isClinicAdminSsoMappingEnabled = (
  input: ClinicUserSsoPolicyInput
): boolean => tenantCapability(
  resolveClinicUserSiteType(input),
  'adminSsoMapping',
  true
);
